import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { personalInfo } from "../data";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-text">
          © {year} <span>{personalInfo.name}</span> · Built with React
        </p>
        <div className="footer-links">
          <a
            href={personalInfo.github}
            target="_blank"
            rel="noreferrer"
            className="footer-link"
            aria-label="GitHub"
          >
            <AiFillGithub />
          </a>
          <a
            href={personalInfo.linkedin}
            target="_blank"
            rel="noreferrer"
            className="footer-link"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

